import { render, staticRenderFns } from "./CheckoutCustomerForm.vue?vue&type=template&id=18ac2a42&scoped=true"
import script from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
export * from "./CheckoutCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCustomerForm.vue?vue&type=style&index=0&id=18ac2a42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac2a42",
  null
  
)

export default component.exports